import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ExternalLink } from "lucide-react";

const FALLBACK = [
  { _id: "p1", title: "Defining the Hampton Roads Luxury Standard", outlet: "Coastal Quarterly", date: "Spring 2025", url: "#", summary: "Upper Crest Image profiled for setting new editorial standards in regional luxury branding." },
  { _id: "p2", title: "Inside the Studio: How Image Becomes Influence", outlet: "Atlas Review", date: "2024", url: "#", summary: "A long-form feature on the studio's approach to image-led influence." },
  { _id: "p3", title: "Built for Brands Ready to Lead", outlet: "Pinnacle Magazine", date: "2024", url: "#", summary: "Commentary on the studio's signature methodology for principals." },
];

export default function PressPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/press").then((r) => setItems(r.data.length ? r.data : FALLBACK)).catch(() => setItems(FALLBACK));
  }, []);
  return (
    <div data-testid="press-page">
      <section className="max-w-[1200px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-12">
        <div className="eyebrow text-[var(--crest-gold)]">— Press & Media</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02]">Press wall.</h1>
      </section>
      <section className="max-w-[1200px] mx-auto px-6 md:px-10 pb-32 grid md:grid-cols-2 gap-px bg-black/10 border border-black/10">
        {items.map((p) => (
          <a key={p._id} href={p.url} target="_blank" rel="noreferrer" className="bg-white p-8 hover:bg-[var(--crest-cream-soft)] group" data-testid={`press-${p._id}`}>
            <div className="eyebrow text-[var(--crest-gold)]">{p.outlet} · {p.date}</div>
            <h3 className="font-serif text-2xl mt-3 group-hover:text-[var(--crest-gold)] transition-colors">{p.title}</h3>
            {p.summary && <p className="text-sm text-[var(--crest-muted)] mt-3 leading-relaxed">{p.summary}</p>}
            <div className="mt-6 btn-ghost-gold inline-flex"><span>Read</span> <ExternalLink size={14} /></div>
          </a>
        ))}
      </section>
    </div>
  );
}
